<template>
    <div>
        <router-view />
        <div id="cloudflare_invisible" class="cloudflare_invisible_hidden"></div>
    </div>
</template>

<script setup>
import send from "@/utils/sendStatistics";

send.init();
</script>
<style lang="scss"></style>
